(function () {
  'use strict';

  var SELECTOR = 'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]';
  var ID_RE = /\/embed\/([a-zA-Z0-9_-]{6,})/;

  function extractVideoId(src) {
    var m = src.match(ID_RE);
    return m ? m[1] : null;
  }

  function buildFacade(iframe) {
    var src = iframe.getAttribute('src');
    if (!src) return null;
    var videoId = extractVideoId(src);
    if (!videoId) return null;

    var facade = document.createElement('div');
    facade.className = 'yt-facade';
    facade.setAttribute('role', 'button');
    facade.setAttribute('tabindex', '0');
    facade.setAttribute('aria-label', iframe.getAttribute('title') || 'Play YouTube video');
    facade.dataset.ytSrc = src;

    // Thumbnail fallback chain. maxresdefault only exists for HD uploads;
    // when it's missing YouTube serves a 120x90 gray placeholder JPEG with a
    // 404 status. Because that placeholder is a valid, decodable image the
    // browser fires `load` (not `error`), so an onerror-only fallback never
    // triggers. We detect the placeholder by its dimensions and advance the
    // chain. hqdefault always exists for any valid video.
    var THUMBS = [
      { name: 'maxresdefault', w: 1280, h: 720 },
      { name: 'hqdefault', w: 480, h: 360 },
      { name: 'mqdefault', w: 320, h: 180 }
    ];
    var step = 0;

    var img = document.createElement('img');
    img.className = 'yt-facade__thumb';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = '';

    function loadThumb() {
      var t = THUMBS[step];
      img.width = t.w;
      img.height = t.h;
      img.src = 'https://i.ytimg.com/vi/' + videoId + '/' + t.name + '.jpg';
    }

    function advance() {
      if (step >= THUMBS.length - 1) return false;
      step++;
      loadThumb();
      return true;
    }

    img.onload = function () {
      // YouTube's gray "no thumbnail" placeholder is 120x90.
      if (img.naturalWidth <= 120 && img.naturalHeight <= 90) {
        advance();
      }
    };
    img.onerror = function () {
      advance();
    };

    loadThumb();
    facade.appendChild(img);

    var btn = document.createElement('button');
    btn.className = 'yt-facade__play';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Play');
    btn.tabIndex = -1;
    btn.innerHTML = '<svg viewBox="0 0 68 48" aria-hidden="true" focusable="false"><path class="yt-facade__play-bg" d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74 0 13.05 0 24 0 24s0 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C68 34.95 68 24 68 24s0-10.95-1.48-16.26z"/><path d="M45 24L27 14v20" fill="#fff"/></svg>';
    facade.appendChild(btn);

    var cs = window.getComputedStyle(iframe);
    if (cs.position === 'absolute' || cs.position === 'fixed') {
      facade.classList.add('yt-facade--positioned');
    }

    return facade;
  }

  function activate(facade) {
    if (facade.classList.contains('yt-facade--active')) return;
    var src = facade.dataset.ytSrc;
    if (!src) return;

    src = src.replace('//www.youtube.com/', '//www.youtube-nocookie.com/')
             .replace('//youtube.com/', '//www.youtube-nocookie.com/');
    if (src.indexOf('autoplay=') === -1) {
      src += (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
    }

    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.className = 'yt-facade__iframe';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');

    facade.innerHTML = '';
    facade.appendChild(iframe);
    facade.classList.add('yt-facade--active');
    facade.removeAttribute('role');
    facade.removeAttribute('tabindex');
  }

  function init() {
    var iframes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];
      if (!iframe.getAttribute('src')) continue;
      var facade = buildFacade(iframe);
      if (facade && iframe.parentNode) {
        iframe.parentNode.replaceChild(facade, iframe);
      }
    }

    document.addEventListener('click', function (e) {
      var facade = e.target.closest && e.target.closest('.yt-facade');
      if (!facade) return;
      e.preventDefault();
      activate(facade);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
      var facade = e.target.closest && e.target.closest('.yt-facade');
      if (!facade || facade.classList.contains('yt-facade--active')) return;
      e.preventDefault();
      activate(facade);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
